import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: fixed;
  top: ${props => props.hidden ? '-100px' : '0'};
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: transparent;
  z-index: 1000;
  transition: top 0.3s ease;
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  background: ${props => props.theme.colors.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const CAButton = styled.button`
  background: ${props => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.theme.colors.accent};
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const BuyButton = styled.a`
  background: ${props => props.theme.colors.gradient};
  color: white;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  display: inline-block;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 1.5rem;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${props => props.theme.colors.secondary};
    transform: translateY(-2px);
  }
`;

const CopyMessage = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: rgba(20, 241, 149, 0.9);
  color: black;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  pointer-events: none;
  opacity: ${props => (props.visible ? '1' : '0')};
  transform: translateY(${props => (props.visible ? '0' : '-10px')});
  transition: all 0.3s ease;
`;

const Header = () => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [hidden, setHidden] = useState(false);
  const contractAddress = "4ekTKyabGdy51ipb9q3e6h8jqHAaHB6azEYdvh8x7vBi";
  
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      
      setHidden(currentScrollPos > 10);
      
      setPrevScrollPos(currentScrollPos);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos]);
  
  const handleCopyCA = async () => {
    try {
      await navigator.clipboard.writeText(contractAddress);
      setCopySuccess(true);
      
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
  
  return (
    <HeaderContainer hidden={hidden}>
      <Logo>MRH</Logo>
      <ButtonsContainer>
        <div style={{ position: 'relative' }}>
          <CAButton onClick={handleCopyCA}>
            CA
          </CAButton>
          <CopyMessage visible={copySuccess}>Address copied!</CopyMessage>
        </div>
        <SocialIcon href="https://t.me/memeretire" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-telegram-plane"></i>
        </SocialIcon>
        <SocialIcon href="https://x.com/meme_retirement" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter"></i>
        </SocialIcon>
        <BuyButton href="https://dexscreener.com/solana/4ekTKyabGdy51ipb9q3e6h8jqHAaHB6azEYdvh8x7vBi" target="_blank" rel="noopener noreferrer">
          Chart
        </BuyButton>
        <BuyButton href="https://raydium.io/swap/?outputMint=4ekTKyabGdy51ipb9q3e6h8jqHAaHB6azEYdvh8x7vBi&inputMint=sol" target="_blank" rel="noopener noreferrer">
          Buy
        </BuyButton>
      </ButtonsContainer>
    </HeaderContainer>
  );
};

export default Header; 